import React, { useState, useEffect, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import choVayConst, { LaiSuatText3 } from "constants/choVayConst";
import { formatNumber } from "utils/currencyFormat";
import XuatExcelApi from "../../../../service/xuatExcelApi"
import ChiTietCuaHangApi from "../../../../service/chiTietCuaHangApi"
export const XuatExcelTraGop = (props) => {
    const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };
    const componentRef = useRef();
    const [tongBanGhi, setTongBanGhi] = useState(0);
    const [danhSachTraGop, setDanhSachTraGop] = useState([]);
    const [percent, setPercent] = useState(0);
    const [maCuaHang, setMaCuaHang] = useState('');
    const [noidung, setNoiDung] = useState('Đang phân tích dữ liệu. Vui lòng chờ đến khi xuất được tập tài liệu.');
    useEffect(() => {
        let dsTraGop = [];
        let tong = 0;
        let pageCount = 0;
        let curent = 1;
        let percurent = 0;

        ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
            setMaCuaHang(response.data.Code);
        });

        XuatExcelApi.kiemTraDuLieuTraGop(props.dataSearch).then((response) => {
            tong = response.data.TotalQuantity;
            pageCount = Math.ceil(tong / 500);
            let perPage = Math.floor(100 / pageCount);
            if (perPage <= 0)
                perPage = 0.001;
            const fetchData = async () => {

                XuatExcelApi.dulieuTraGop(
                    props.dataSearch.dateFrom,
                    props.dataSearch.dateTo,
                    props.dataSearch.code,
                    props.dataSearch.customerName,
                    props.dataSearch.address,
                    props.dataSearch.noteTaiSan,
                    props.dataSearch.status,
                    props.dataSearch.debt,
                    props.dataSearch.userName,
                    curent,
                    props.dataSearch.taiSan,
                    props.dataSearch.dongtungay,
                    props.dataSearch.dongdenngay,
                ).then((response) => {
                    response.data.List && response.data.List.map((item, index) => (
                        dsTraGop.push(item)
                    ))
                    curent++;
                    percurent = percurent + perPage;
                    setPercent(percurent);
                    if (curent <= pageCount && props.show) {
                        sleep(1000).then(r => {
                            fetchData();
                        });

                        if (percurent >= 100) {
                            percurent = 80;
                            setPercent(percurent);
                        }
                    }
                    else {
                        percurent = 100;
                        setPercent(percurent);
                        setNoiDung("Dữ liệu đã tải xong. Vui lòng kiểm tra thư mục download.")
                    }
                    setDanhSachTraGop(dsTraGop);
                    if (percurent >= 100 && props.show) {
                        sleep(1500).then(r => {
                            downExcel();
                        });
                    }
                });

            }
            if (percurent === 0 && props.show)
                fetchData();
            setTongBanGhi(response.data.TotalQuantity);

        });


    }, []);
    const downExcel = () => {
        var uri =
            "data:application/vnd.ms-excel;charset=utf-8,%EF%BB%BF" +
            encodeURIComponent(document.getElementById("htmlExcel").innerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            "DanhSachTraGop_" + moment().format("YYYYMMDDHHmm") + ".xls";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    return (
        <>
            <Modal
                show={props.show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="modal-new modal fade text-left"
            >
                <Modal.Header>
                    <h4 className="modal-title" id="myModalLabel16">
                        <span className="btn-icon-right">
                            <i className="mdi mdi-file-document"></i>
                        </span>
                        Xuất excel dữ liệu cầm đồ
                    </h4>
                    {percent === 100 && (
                        <button type="button" className="close-popup-new" onClick={props.onHide}>
                            <i className="mdi mdi-close"></i>
                        </button>
                    )}
                </Modal.Header>
                <Modal.Body className="">
                    <div className="form-thongtin-kh-new">
                        <div id="accordionWrap6" role="tablist" aria-multiselectable="true">
                            <div className="card collapse-icon accordion-icon-rotate" style={{ textAlign: "center" }}>
                                {noidung}
                            </div>
                            <div>
                                <div style={{ width: "100%", backgroundColor: "#CCCCCC", height: "20px" }}>
                                    <div style={{ width: percent + "%", backgroundColor: "#006266", height: "20px", textAlign: "center", fontWeight: "bold", color: "#FFF", fontSize: "12px" }}>
                                        {percent} %
                                    </div>
                                </div>
                            </div>
                            <div style={{ overflow: "scroll", display: "none" }} id="htmlExcel">

                                {/* <TraGopDataPrint ref={componentRef} dataPrint={danhSachTraGop} maCuaHang={maCuaHang} ></TraGopDataPrint> */}
                                <table style={{ border: "1px solid #CCCCCC", width: "100%", color: "#000000" }}>
                                    <tr style={{ backgroundColor: "#b9edc6", color: "#063e02", fontWeight: "bold" }}>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>STT</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã cửa hàng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã KH</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tên khách hàng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>CCCD</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã tài sản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Loại tài sản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tên Tài sản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã hợp đồng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã gói vay</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày Vay</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Thời gian vay</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Loại hợp đồng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày tạo hợp đồng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Giá cửa hàng đề xuất</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Gói vay Ô tô</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Hình thức trả lãi</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã giảm giá</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Hình thức khuyến mãi</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Kỳ khuyến mãi</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Khuyến mãi lãi</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Khuyển mãi Phí thẩm định</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Khuyển mãi Phí bảo quản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Khuyến mãi chi phí vay (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tiền thưởng (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Khuyến mãi tiền mặt (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Lãi suất </td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Kiểu lãi suất</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Phí thẩm định</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Phí bảo quản (%)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Lãi và Phí</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Phí khác</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền còn lại</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền đã trả</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã NV phê duyệt</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiến nợ</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền dư của KH</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Hạng HĐ</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày vay thêm</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền vay thêm</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày trả bớt gốc</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền trả bớt gốc</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Nợ gốc còn</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tổng số kỳ lãi đã đóng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tổng số tiền lãi đã đóng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày đóng lãi gần nhất</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền kỳ lãi gần nhất</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày đóng lãi kỳ tới</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền kì lãi kì tới</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngày đóng hợp đồng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền đóng HĐ</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã NV thẩm định 1</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã NV thẩm định 2</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Hình thức giải ngân</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số tiền mặt chuyển KH</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Người nhận</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tiền chuyển khoản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ngân Hàng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Chi nhánh</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tên chủ tài khoản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số TK</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tình trạng HĐ</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số ngày quá hạn</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số kỳ quá hạn</td>
                                    </tr>
                                    {danhSachTraGop && danhSachTraGop.map((item, index) => (
                                        <tr>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{index + 1}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{maCuaHang}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.CustomerName}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.CMT.toString()}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.MaTaiSan}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.LoaiTaiSan}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.TenTaiSan}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.Code}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.NgayVay}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>
                                                {item.BocTrongVong}
                                            </td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.CreatedTime}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.HinhThucTraLai}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>
                                                {item.Type !== 2 && (
                                                    formatNumber(LaiSuatText3(item, item.KieuLaiSuat))
                                                )}
                                                {item.Type === 2 && (
                                                    <p>
                                                        {item.StatusPaidHo === 1 &&
                                                            formatNumber(
                                                                Math.ceil(item.ValueLai * item.CountTypePaid),
                                                            )}
                                                        {item.StatusPaidHo === 2 &&
                                                            formatNumber(
                                                                Math.ceil(item.ValueLai * item.BocTrongVong),
                                                            )}
                                                        {item.StatusPaidHo === 3 && item.ChiPhiVay.toFixed(2)}
                                                    </p>
                                                )}
                                            </td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.TypePaid === 1 ? "Ngày" : "Tháng"}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.SoTienDongHopDong === null || formatNumber(item.SoTienDongHopDong) === 0 ? formatNumber(item.SoTienVayConLai) : 0}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.Paided)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.NgayVayThem}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.SoTienVayThem)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.NgayTraBotGoc}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.SoTienTraBotGoc)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.SoTienDongHopDong === null || formatNumber(item.SoTienDongHopDong) === 0 ? formatNumber(item.SoTienVayConLai) : 0}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.TongKyLaiDaDong}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.TongTienLaiDaDong)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.NgayDongLaiGanNhat}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.SoTienKyLaiGanNhat)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.NgayDongLaiKyToi}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.SoTienKyLaiKyToi)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.NgayDongHopDong}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{formatNumber(item.SoTienDongHopDong)}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{choVayConst.StatusText[item.Status]}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.SoNgayChuaDong}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.SoKyChuaDong}</td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal.Body >
                <Modal.Footer>
                    <div className="text-right">
                        {percent === 100 && (
                            <button
                                type="button"
                                className="btn btn-new-main btn-closenew"
                                onClick={props.onHide}
                            >
                                <span className="btn-icon-left">
                                    <i className="mdi mdi-close"></i>
                                </span>
                                Đóng
                            </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal >
        </>
    );
};
